var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0267 15.3334H4.97334C4.79653 15.3334 4.62696 15.4387 4.50193 15.6263C4.37691 15.8138 4.30667 16.0682 4.30667 16.3334C4.30667 16.5986 4.37691 16.8529 4.50193 17.0405C4.62696 17.228 4.79653 17.3334 4.97334 17.3334H19.0267C19.2035 17.3334 19.3731 17.228 19.4981 17.0405C19.6231 16.8529 19.6933 16.5986 19.6933 16.3334C19.6933 16.0682 19.6231 15.8138 19.4981 15.6263C19.3731 15.4387 19.2035 15.3334 19.0267 15.3334Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1133 11.3334H4.97334C4.79653 11.3334 4.62696 11.4387 4.50193 11.6263C4.37691 11.8138 4.30667 12.0682 4.30667 12.3334C4.30667 12.5986 4.37691 12.8529 4.50193 13.0405C4.62696 13.228 4.79653 13.3334 4.97334 13.3334H14.1133C14.2901 13.3334 14.4597 13.228 14.5847 13.0405C14.7098 12.8529 14.78 12.5986 14.78 12.3334C14.78 12.0682 14.7098 11.8138 14.5847 11.6263C14.4597 11.4387 14.2901 11.3334 14.1133 11.3334Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16 7.33337H4.97334C4.79653 7.33337 4.62696 7.43873 4.50193 7.62627C4.37691 7.8138 4.30667 8.06816 4.30667 8.33337C4.30667 8.59859 4.37691 8.85295 4.50193 9.04048C4.62696 9.22802 4.79653 9.33337 4.97334 9.33337H9.16C9.33682 9.33337 9.50638 9.22802 9.63141 9.04048C9.75643 8.85295 9.82667 8.59859 9.82667 8.33337C9.82667 8.06816 9.75643 7.8138 9.63141 7.62627C9.50638 7.43873 9.33682 7.33337 9.16 7.33337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy2);
export default __webpack_public_path__ + "static/media/Sort-by2.cde5b0bfbd4cd6dae6e557bcd3bf0cf3.svg";
export { ForwardRef as ReactComponent };